import Question, { QuestionsContainer, QuestionWrapper } from 'components/reports/Question'
import OutputDetails from 'components/reports/OutputDetails'
import ReferrableQuestionWrapper from 'components/reports/ReferrableQuestionWrapper'
import { formatDateMonthYear } from 'hooks/useDateUtils'

export default function LiverDetails({ data }) {

    var questions = data.conditionSpecific.questions

    return (
        <>
            <h3>Liver/Blood Conditions Questions</h3>

            <QuestionsContainer>

                <QuestionWrapper number='1'>
                    <Question>Please provide the exact diagnosis of this condition:</Question>
                    <ReferrableQuestionWrapper isReferred={questions.exactDiagnosis.referToAttachments}>
                        <p>{questions.exactDiagnosis.value}</p>
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

                <QuestionWrapper number='2'>
                    <Question>Please confirm the date of diagnosis and presenting symptoms:</Question>
                    <ReferrableQuestionWrapper isReferred={questions.diagnosisDetails.referToAttachments}>
                        <Question>Date of Diagnosis:</Question>
                        <p>{formatDateMonthYear(questions.diagnosisDetails.subQuestions.dateOfDiagnosis)}</p>

                        <Question>Presenting symptoms:</Question>
                        <p>{questions.diagnosisDetails.subQuestions.presentingSymptoms}</p>
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

                <QuestionWrapper number='3'>
                    <Question>Please confirm date and results of blood tests at diagnosis (to include relevant reference range):</Question>
                    <ReferrableQuestionWrapper isReferred={questions.bloods.referToAttachments}>
                        <OutputDetails
                            details={questions.bloods.details}
                        />
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

                <QuestionWrapper number='4'>
                    <Question>Please provide the date and result of any investigations in the last 5 years:</Question>
                    <ReferrableQuestionWrapper isReferred={questions.investigations.referToAttachments}>
                        <OutputDetails
                            details={questions.investigations.details}
                        />
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

                <QuestionWrapper number='5'>
                    <Question>Please provide details of treatment in the last 5 years to include dates, duration and date of completion:</Question>
                    <ReferrableQuestionWrapper isReferred={questions.treatmentProvided.referToAttachments}>
                        <p>{questions.treatmentProvided.value}</p>

                        <Question>Treatment Start Date:</Question>
                        <p>{formatDateMonthYear(questions.treatmentProvided.subQuestions.dateStarted)}</p>

                        <Question>Is treatment ongoing?</Question>
                        <p>{questions.treatmentProvided.subQuestions.anyTreatmentOngoing}</p>

                        {questions.treatmentProvided.subQuestions.anyTreatmentOngoing === 'No' && (
                            <>
                                <Question>If no, please provide treatment end date:</Question>
                                <p>{formatDateMonthYear(questions.treatmentProvided.subQuestions.dateEnded)}</p>
                            </>
                        )}
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

                <QuestionWrapper number='6'>
                    <Question>Was any underlying cause established?</Question>
                    <ReferrableQuestionWrapper isReferred={questions.anyUnderlyingCause.referToAttachments}>
                        <p>{questions.anyUnderlyingCause.value}</p>
                        {questions.anyUnderlyingCause.value === 'Yes' && (
                            <>
                                <Question>If yes, please provide details:</Question>
                                <p>{questions.anyUnderlyingCause.details}</p>
                            </>
                        )}
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

                <QuestionWrapper number='7'>
                    <Question>Please provide details of the current status of the condition and any associated complications:</Question>
                    <ReferrableQuestionWrapper isReferred={questions.currentStatus.referToAttachments}>
                        <p>{questions.currentStatus.value}</p>
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

                <QuestionWrapper number='8'>
                    <Question>Please provide details of any associated complications in the last 5 years:</Question>
                    <ReferrableQuestionWrapper isReferred={questions.complications.referToAttachments}>
                        <p>{questions.complications.value}</p>
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

                <QuestionWrapper number='9'>
                    <Question>Are there any other factors or co-morbidities present which may influence the prognosis of this condition?</Question>
                    <ReferrableQuestionWrapper isReferred={questions.anyOtherFactors.referToAttachments}>
                        <p>{questions.anyOtherFactors.value}</p>
                        {questions.anyOtherFactors.value === 'Yes' && (
                            <>
                                <Question>If yes, please provide details:</Question>
                                <p>{questions.anyOtherFactors.details}</p>
                            </>
                        )}
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

            </QuestionsContainer>
        </>
    )
}